import { Button } from "@aidron/aidron-ds";
import React from "react";
import Modal from "react-modal";
import { t } from "i18next";
import { createPercentFormatter, currencyFormatter } from "../../../../utils/formatter/formatter";
import { ProductHierarchyHeading, TextAndLabelView } from "../../../../components/SharedComponents/sharedComponents.index";

const MODAL_STYLE = {
  overlay: {
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: 20000,
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    padding: "2rem",
    textAlign: "center",
    borderRadius: "8px",
    maxWidth: "fit-content",
    width: "100%",
    maxHeight: "80vh",
    overflowY: "auto",
  },
};

const language = localStorage.getItem("i18nextLng") || "pt-BR";

export const RemovedOpportunitiesModal = ({ actions, ctx, uiState }) => {
  const { onClose } = actions || {};

  const { removedOpportunities = [], opportunityTypes = [], products = [] } = ctx || {};

  const { isOpen = false } = uiState || {};  

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      style={MODAL_STYLE}
      contentLabel="Oportunidades removidas"
    >
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "1.25rem",
          }}>
          <p style={{ fontSize: "1rem", fontWeight: 600, margin: 0 }}>
            {language === "En" ? "Removed Opportunities" : "Oportunidades Removidas"}
            <span
              style={{
                marginLeft: "0.5rem",
                backgroundColor: "#f3f4f6",
                color: "#374151",
                borderRadius: "999px",
                padding: "0.1rem 0.55rem",
                fontSize: "0.8rem",
                fontWeight: 600,
              }}
            >
              {removedOpportunities.length}
            </span>
          </p>

          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#9ca3af",
              fontSize: "1.25rem",
              lineHeight: 1,
              padding: "0.1rem 0.3rem",
            }}
            aria-label="Fechar"
          >
            ×
          </button>
        </div>

        {/* List */}

        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: '1rem', backgroundColor: '#fafafa', }}>
          {removedOpportunities.map((opp, index) => {
            const typeInfo = opportunityTypes.find(t => t.value === opp.type1);
            const typeName = typeInfo?.displayName || opp.type1;

            return (
              <React.Fragment key={opp.opportunityId}>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  padding: '0.75rem', 
                  border: '1px solid #f0f0f0', 
                  borderRadius: '6px' 
                }}>
                  <ProductHierarchyHeading ctx={{ products: products, productId: opp.productId }} />
                </div>

                <div style={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  justifyContent: 'center', 
                  alignItems: 'center', 
                  padding: '0 20px', 
                  textAlign: 'center', 
                  borderInlineStart: 'solid 1px #919191',
                  borderBlock: 'solid 1px #e5e7eb'
                }}>
                  <TextAndLabelView label={t("opportunity")} labelSize="xs" text={typeName} />
                </div>

                <div style={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  justifyContent: 'center', 
                  alignItems: 'center', 
                  padding: '0 20px', 
                  textAlign: 'center', 
                  borderInline: 'solid 1px #919191',
                  borderBlock: 'solid 1px #e5e7eb'
                }}>
                  <TextAndLabelView
                    label={t("percent")}
                    labelSize="xs"
                    heading={`${opp.percent > 0 ? "↑" : "↓"} ${
                      createPercentFormatter({ 
                        minimumFractionDigits: 0, 
                        maximumFractionDigits: 0 
                      }).format(opp.percent / 100)}`}
                    contentSize="md" />
                </div>

                <div style={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  justifyContent: 'center', 
                  alignItems: 'center', 
                  padding: '0 20px', 
                  textAlign: 'center', 
                  borderInlineEnd: 'solid 1px #919191',
                  borderBlock: 'solid 1px #e5e7eb'
                }}>
                  <TextAndLabelView
                    label={t("opportunitySize")}
                    labelSize="xs"
                    heading={currencyFormatter.format(opp.value)}
                    contentSize="md" />
                </div>
              </React.Fragment>
            );
          })}
        </div>

        {/* Footer button */}

        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
            <Button
                label={t("close")}
                onClick={onClose}
                size="sm"
                type="filled"
                variant="primary"/>
        </div>
    </Modal>
  );
};